// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1Qlxw","col":"CardReaderDesc_col__1mUyt","label":"CardReaderDesc_label__1T1r3"};